import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '114373', // #002b48
        secondary: '002b48', // #FFCDD2
        accent: 'e60896' // #3F51B5
      }
    }
  }
});
